import { ref, computed, defineAsyncComponent } from "vue";
import { menuConfig } from "@/views/dashboard/menuConfig";

// 全局状态变量
const activePrimaryMenu = ref("cloudspace");
const activeSecondaryMenu = ref("files");

// 全局计算属性
const primaryMenus = computed(() =>
  Object.entries(menuConfig).map(([key, config]) => ({
    key,
    title: config.title,
    icon: config.icon,
    disabled: config.disabled || key === "tools" || key === "statistic",
  }))
);

const primaryMenuTitle = computed(
  () => menuConfig[activePrimaryMenu.value]?.title || ""
);

const currentSecondaryMenus = computed(
  () => menuConfig[activePrimaryMenu.value]?.items || []
);

const secondaryMenuTitle = computed(() => {
  const item = findSecondaryMenuItem(
    activePrimaryMenu.value,
    activeSecondaryMenu.value
  );
  return item?.title || "";
});

const currentView = computed(() => {
  const item = findSecondaryMenuItem(
    activePrimaryMenu.value,
    activeSecondaryMenu.value
  );
  return (
    item?.component ||
    defineAsyncComponent(() =>
      import("@/views/dashboard/cloudspace/files/FilesView.vue")
    )
  );
});

// 验证菜单组合是否有效
const isValidMenuCombination = (primary, secondary) => {
  const primaryMenuExists = menuConfig[primary];
  if (!primaryMenuExists) return false;

  const secondaryMenuExists = primaryMenuExists.items.find(
    (item) => item.key === secondary
  );
  return !!secondaryMenuExists;
};

// 查找菜单项
const findSecondaryMenuItem = (primaryMenu, secondaryMenuKey) => {
  return menuConfig[primaryMenu]?.items.find(
    (item) => item.key === secondaryMenuKey
  );
};

// 更新菜单状态
const updateMenuState = (primaryMenu, secondaryMenu) => {
  if (isValidMenuCombination(primaryMenu, secondaryMenu)) {
    activePrimaryMenu.value = primaryMenu;
    activeSecondaryMenu.value = secondaryMenu;
    return true;
  }
  return false;
};

// 获取默认二级菜单
const getDefaultSecondaryMenu = (primaryMenuKey) => {
  return menuConfig[primaryMenuKey]?.items.find((item) => !item.type);
};

// 添加抽屉状态控制
const showDrawer = ref(false);

// 添加到 action 对象中
const toggleDrawer = (value) => {
  showDrawer.value = value;
};

export const useDashboard = () => {
  // 处理主菜单点击事件
  const handlePrimaryMenuClick = (router, primaryMenuKey) => {
    const defaultSecondaryMenu = getDefaultSecondaryMenu(primaryMenuKey);
    if (!defaultSecondaryMenu) return;

    router.push(`/${primaryMenuKey}/${defaultSecondaryMenu.key}`);
  };

  // 处理二级菜单点击事件
  const handleSecondaryMenuClick = (router, secondaryMenuKey) => {
    router.push(`/${activePrimaryMenu.value}/${secondaryMenuKey}`);
  };

  // 返回首页方法
  const backToHome = async (router) => {
    try {
      await router.push("/");
    } catch (error) {
      console.error("Navigation to home failed:", error);
    }
  };

  return {
    state: {
      activePrimaryMenu,
      activeSecondaryMenu,
      primaryMenuTitle,
      secondaryMenuTitle,
      primaryMenus,
      currentSecondaryMenus,
      currentView,
      showDrawer,
    },
    action: {
      handlePrimaryMenuClick,
      handleSecondaryMenuClick,
      backToHome,
      updateMenuState,
      toggleDrawer,
    },
  };
};
